export class DropdownItem {
    item_id: string;
    item_text: string;
}
